import React from 'react';
import Button from 'components/Button/Button';

import IconInfo from 'icons/ic_ErrorInfo.svg';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const BrokenImages: React.FC<ComponentProps> = ({ styles, closeModal }) => {
  const [title, body, label] = [
    'Oops! Looks like there’s an issue with some of your photos.',
    'These photos will not show in your apps. You can re-upload them at any time.',
    'Ok, got it'
  ];
  return (
    <div
      className="Error-Modal"
      data-testid="broken-image-error-modal"
      role="dialog"
      aria-labelledby="photo-error-title"
      aria-describedby="photo-error-description"
    >
      <img src={IconInfo} alt="info-icon" />
      <h2 id="photo-error-title">{title}</h2>
      <p data-testid="error-modal-copy" id="photo-error-description">
        {body}
      </p>
      <div data-testid="button-row" className={`${styles.ButtonRow} ${styles.Single}`}>
        <Button
          key={label}
          onClick={() => {
            closeModal();
          }}
        >
          <span id="error-button-label">{label}</span>
        </Button>
      </div>
    </div>
  );
};

export default BrokenImages;
